/* eslint-disable import/prefer-default-export */
import React from 'react';
import { FormattedRelative } from 'decisiv-domain-utils';
import moment from 'moment-timezone';

import { userTimeZone } from 'utils/timeUtils';

/**
 * Get and format the relative case creation date/time from the given
 * case information
 *
 * @param caseInfo - an immutable map of case information
 */
export function getCaseCreated(caseInfo) {
  const requestedAt = caseInfo.get('requestedAt');
  return requestedAt &&
    <FormattedRelative
      render={relativeTime => <span>{relativeTime}</span>}
      value={moment.tz(requestedAt, userTimeZone())}
    />;
}



// WEBPACK FOOTER //
// ./components/CaseDisplayElement/helpers.js